export default __webpack_public_path__ + "static/media/ato_mail.13dfd25e.svg";